import React, { useState } from "react";
import {
    SelectChangeEvent,
    Select,
    MenuItem,
    Tabs,
    Tab,
    Drawer,
    IconButton,
    Button,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";

import ProductCard from "../../../components/ProductCard";
import ProductsFilter from "../../../components/ProductFilter";

const MyWhistlist = () => {
    const [value, setValue] = useState(0);
    const [sort, setSort] = useState("0");

    const [filterOpen, setFilterOpen] = useState(false); // drawer state

    const handleChangeSort = (event: SelectChangeEvent) => {
        setSort(event.target.value);
    };

    const productsList = [
        {
            image: '/static/images/product_image_01.jpg',
            rating: '4.6',
            brand: 'Palmonas',
            name: 'Gold Chain',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_02.jpg',
            rating: '4.6',
            brand: 'Zara',
            name: 'Men Shirt XL',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_03.jpg',
            rating: '4.6',
            brand: 'Nike',
            name: 'Men Sports Shoes',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_04.jpg',
            rating: '4.6',
            brand: 'Ferulic',
            name: 'Skin Ceuticals',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_05.jpg',
            rating: '4.6',
            brand: 'Apple',
            name: 'Series 11',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_01.jpg',
            rating: '4.6',
            brand: 'Palmonas',
            name: 'Gold Chain',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_02.jpg',
            rating: '4.6',
            brand: 'Zara',
            name: 'Men Shirt XL',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_03.jpg',
            rating: '4.6',
            brand: 'Nike',
            name: 'Men Sports Shoes',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_04.jpg',
            rating: '4.6',
            brand: 'Ferulic',
            name: 'Skin Ceuticals',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_05.jpg',
            rating: '4.6',
            brand: 'Apple',
            name: 'Series 11',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_01.jpg',
            rating: '4.6',
            brand: 'Palmonas',
            name: 'Gold Chain',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_02.jpg',
            rating: '4.6',
            brand: 'Zara',
            name: 'Men Shirt XL',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_03.jpg',
            rating: '4.6',
            brand: 'Nike',
            name: 'Men Sports Shoes',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_04.jpg',
            rating: '4.6',
            brand: 'Ferulic',
            name: 'Skin Ceuticals',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_05.jpg',
            rating: '4.6',
            brand: 'Apple',
            name: 'Series 11',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_01.jpg',
            rating: '4.6',
            brand: 'Palmonas',
            name: 'Gold Chain',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_02.jpg',
            rating: '4.6',
            brand: 'Zara',
            name: 'Men Shirt XL',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_03.jpg',
            rating: '4.6',
            brand: 'Nike',
            name: 'Men Sports Shoes',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_04.jpg',
            rating: '4.6',
            brand: 'Ferulic',
            name: 'Skin Ceuticals',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_05.jpg',
            rating: '4.6',
            brand: 'Apple',
            name: 'Series 11',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_01.jpg',
            rating: '4.6',
            brand: 'Palmonas',
            name: 'Gold Chain',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_02.jpg',
            rating: '4.6',
            brand: 'Zara',
            name: 'Men Shirt XL',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_03.jpg',
            rating: '4.6',
            brand: 'Nike',
            name: 'Men Sports Shoes',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
        {
            image: '/static/images/product_image_04.jpg',
            rating: '4.6',
            brand: 'Ferulic',
            name: 'Skin Ceuticals',
            price: 500,
            originalPrice: 800,
            discount: 30,
        },
    ];

    return (
        <>
            {/* Filter Drawer (Mobile Only) */}
            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                sx={{
                    "& .MuiDrawer-paper": { width: 300, padding: "20px" },
                }}
            >
                <IconButton
                    onClick={() => setFilterOpen(false)}
                    sx={{ mb: 2, alignSelf: "flex-end" }}
                >
                    <CloseIcon />
                </IconButton>

                <ProductsFilter />
            </Drawer>

            <section className="wrap_productListing uh_spc">
                <div className="container">
                    <div className="page_head hd_4">
                        <div className="lt">
                            <h1>My Wishlist</h1>

                        </div>

                        <div className="rt">
                            <Button
                                className="filter_btn_mobile btn btn_primary"
                                onClick={() => setFilterOpen(true)}
                            >
                                <FilterListIcon /> Filters
                            </Button>
                        </div>
                    </div>

                    <div className="listing_grid">

                        <div className="rt custom_tabs1">
                            <div className="form sort_row">
                                <p className="size_big">Showing 57,877 Results</p>
                                <Select onChange={handleChangeSort} value={sort}>
                                    <MenuItem value={0} disabled>
                                        Sort
                                    </MenuItem>
                                    <MenuItem value={10}>High to low</MenuItem>
                                    <MenuItem value={20}>Low to high</MenuItem>
                                </Select>
                            </div>

                            <Tabs
                                value={value}
                                onChange={(e, newValue) => setValue(newValue)}
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="scrollable tabs"
                                   className="custom_tabs_links"
                            >
                                <Tab label="Sports" />
                                <Tab label="Sneakers" />
                                <Tab label="Slippers" />
                                <Tab label="Loafers" />
                                <Tab label="Sandals" />
                                <Tab label="Boots" />
                                <Tab label="Formal" />
                            </Tabs>

                            <ProductCard products={productsList} className="card_sm" />
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
};

export default MyWhistlist;
